import Cookies from "js-cookie";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import debounce from "lodash/debounce";

const FeeSchedulesTable = () => {
  const [maxExceed, setMaxExceed] = useState<string>("");
  const [rows, setRows] = useState<any>([
    { id: 1, disabled: false, value: "0", entered: false },
  ]);
  const [recentlyAddedRow, setRecentlyAddedRow] = useState(null);

  function handleChange(event: any, index: number) {
    const { name, value } = event.target;
    const updatedRows = [...rows];
    updatedRows[index][name] = value;
    updatedRows[index].entered = value !== "";

    // Check if the feeType is 'fixed' and disable input fields accordingly
    if (value === "fixed") {
      updatedRows[index].disabled = true;
    } else {
      updatedRows[index].disabled = false;
    }

    setRows(updatedRows);
  }

  function handleRemoveRow(index: number) {
    const updatedRows = [...rows];
    updatedRows.splice(index, 1);

    // Re-enable the input fields in the previous row if it exists
    if (index > 0 && updatedRows[index - 1]) {
      updatedRows[index - 1].disabled = false;
    }

    setRows(updatedRows);
    setRecentlyAddedRow(null);
  }

  const lastObject = rows[rows.length - 1];
  console.log("row", rows, recentlyAddedRow);
  const rowDisabled = rows[rows.feeType === "fixed" ? 1 : 0];

  function handleAddRow() {
    const sumMaxValue = rows.reduce(
      (acc: any, curr: any) => acc + parseFloat(curr.maxValue),
      0
    );
    const newMaxValue = parseFloat(rows[rows.length - 1].maxValue);

    if (sumMaxValue + newMaxValue >= 1000000000000.0) {
      setMaxExceed("Cannot add new row, maximum threshold exceeded.");
      console.log("Cannot add new row, maximum threshold exceeded.");
      return;
    } else {
      setMaxExceed("");
    }

    const newId = rows.length + 1;
    const newMinValue = (newMaxValue + 0.1).toFixed(1);

    // Create a new row with entered set to false
    const newRow = {
      id: newId,
      disabled: false, // Newly added row is not disabled
      value: "0",
      minValue: newMinValue,
      entered: false,
    };

    // Disable all input fields in the existing rows
    const updatedRows = rows.map((row: any) => ({
      ...row,
      disabled: true,
    }));

    updatedRows.push(newRow); // Add the new row

    setRows(updatedRows);
    setRecentlyAddedRow(newId);
  }

  const constructPayload = () => {
    const payload = {
      feeSchedules: rows.map((row: any) => ({
        feeType: row.feeType,
        minValue: row.minValue,
        maxValue: row.maxValue,
        feeBps: row.feeBps,
      })),
    };

    return payload;
  };

  const handleSubmit = () => {
    const payload = constructPayload();

    // Send the payload, e.g., by making an API call
    // fetch('/api/endpoint', {
    //   method: 'POST',
    //   body: JSON.stringify(payload),
    //   headers: {
    //     'Content-Type': 'application/json'
    //   }
    // })
    // .then(response => response.json())
    // .then(data => {
    //   // Handle response
    // })
    // .catch(error => {
    //   // Handle error
    // });
  };

  console.log("lastObject.feeBps", lastObject.feeBps);

  return (
    <div className="mt-4">
      <div className="card mr-2 shadow-none position-relative top-4">
        {maxExceed ? (
          <div
            className="alert alert-danger position-absolute p-2"
            style={{ top: "-40px", width: "100%" }}
            role="alert"
          >
            {maxExceed}
          </div>
        ) : null}
        <div className="card-body p-0">
          <div className="chart chart-xs">
            <div className="chartjs-size-monitor">
              <div
                className="chartjs-size-monitor-shrink row"
                style={{ height: "580px" }}
              >
                <table
                  id="UpdateTargets"
                  className="table table-striped my-0 table-fixed"
                  style={{ height: "550px" }}
                >
                  <thead>
                    <tr style={{ height: "42px", verticalAlign: "middle" }}>
                      <th className="text-Start ">Fee Schedule ID</th>
                      <th className="d-none d-xl-table-cell ">Fee Type</th>
                      <th className="d-none d-xl-table-cell">Min Amount</th>
                      <th className="d-none d-xl-table-cell">Max Amount</th>
                      <th className="d-none d-xl-table-cell">FeeBps</th>
                      <th className="d-none d-xl-table-cell">Action</th>
                    </tr>
                  </thead>
                  <tbody style={{ overflowY: "auto" }}>
                    {rows.map((row: any, index: any) => (
                      <tr key={row.id}>
                        <td className="text-start">1</td>
                        <td className="d-none d-xl-table-cell px-3">
                          <select
                            className="form-control secure-input-field"
                            onChange={(event) => handleChange(event, index)}
                            name="feeType"
                            disabled={row.disabled && index !== rows.length - 1} // Disable select only if row.disabled and not the current row
                          >
                            <option value="sliding">Sliding</option>
                            <option value="fixed">Fixed</option>
                          </select>
                        </td>
                        <td className="d-none d-xl-table-cell px-4">
                          <input
                            className="form-control secure-input-field"
                            type="number"
                            defaultValue={row.minValue}
                            readOnly={row.disabled}
                            disabled={row.disabled}
                            onChange={(event) => handleChange(event, index)}
                            name="minValue"
                          />
                        </td>
                        <td className="d-none d-xl-table-cell px-4">
                          <input
                            className="form-control secure-input-field"
                            type="number"
                            defaultValue="0"
                            disabled={row.disabled}
                            readOnly={row.disabled}
                            onChange={(event) => handleChange(event, index)}
                            name="maxValue"
                          />
                        </td>
                        <td className="d-none d-xl-table-cell px-4">
                          <input
                            className="form-control secure-input-field"
                            type="number"
                            defaultValue="0"
                            disabled={row.disabled}
                            readOnly={row.disabled}
                            onChange={(event) => handleChange(event, index)}
                            name="feeBps"
                          />
                        </td>
                        <td className="d-none d-xl-table-cell px-4">
                          {index === rows.length - 1 && (
                            <>
                              {lastObject.maxValue !== undefined &&
                              lastObject.minValue !== undefined &&
                              lastObject.feeBps !== undefined ? (
                                <button
                                  className="btn"
                                  onClick={() => handleAddRow()}
                                  disabled={
                                    rowDisabled?.feeType === "fixed" ?? true
                                  }
                                >
                                  +
                                </button>
                              ) : null}

                              {index !== 0 && (
                                <button
                                  className="btn"
                                  onClick={() => handleRemoveRow(index)}
                                  disabled={
                                    rowDisabled?.feeType === "fixed" ?? true
                                  }
                                >
                                  -
                                </button>
                              )}
                            </>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="row pt-4">
                <div className="float-end text-end">
                  <button type="button" className="btn btn-link">
                    Cancel
                  </button>
                  {maxExceed ? (
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleSubmit}
                    >
                      Submit
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { FeeSchedulesTable };
